import React, { Component, Fragment } from 'react';
import {
    LoadingComponent,
    PageListComponent,
    HeaderListComponent,
    FormActionComponent,
    FormWrapperItem, FormWrapperInputComponent,
} from "../../../common/component/Index";
import { PATHS, UPLOAD_DIRECTORY, DETAIL_ACTIONS, FEATURE_FLAGS } from "../../../../../constants/Define";
import { isEqual, get, cloneDeep, find } from 'lodash';
import * as Func from '../../../../../helpers/functions';
import Page from '../../../../../models/Page';
import Wrapper from './../../../common/component/Wrapper';

import './PageDetail.less';
import Input from "../../../common/component/Input";
import { checkUndefine } from "../../../../../helpers/functions";
import RichTextEditor, { ClassicEditor } from "../../../common/component/RichTextEditor";
import Span from '../../../common/component/Span';
import TranslateButton from '../../../common/component/TranslateButton';

let permisionActions = [];
const defaultState = {
    action: DETAIL_ACTIONS.CREATE,
    isSubmit: false,
    isGetItem: false,
    validation: {},
};

export default class PageDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            page: this.props.pageState.detail.page,
        };
    }

    componentDidMount() {
        this.initDetail()
    }

    initDetail() {
        const { match, pageState } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.id) {
            const id = match.params.id;
            this.setState({ action: DETAIL_ACTIONS.UPDATE });
            const page = find(pageState.pages, h => h.id === id);
            // if(page) this.setState({page});
            this.props.getPageDetail(id);
        }
    }

    componentWillUnmount() {
        this.props.setPageDetail(new Page())
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.pageState.detail.page && !isEqual(nextProps.pageState.detail.page, this.props.pageState.detail.page)) {
            this.setState({ page: nextProps.pageState.detail.page, action: nextProps.pageState.detail.page.id ? DETAIL_ACTIONS.UPDATE : this.state.action });
        }
    }

    render() {
        const { t, uploadState, pageState } = this.props;
        const { isFetching } = pageState;
        const { action, isSubmit, isGetItem, validation, page } = this.state;
        return (
            <LoadingComponent spinning={isFetching || isSubmit}>
                <PageListComponent className="page-detail-page">
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'pages'}
                        titleHeader={action === DETAIL_ACTIONS.CREATE
                            ? Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.page.title_page')}`).toLowerCase())
                            : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.page.title_page')}`.toLowerCase()))
                        }
                        componentRight={FEATURE_FLAGS.TRANSLATE_ENABLE &&
                            <TranslateButton
                                languages={page.translations}
                                current={page.languageCode}
                                validation={validation.languageCode}
                                onChange={this.onShowTranslate}
                                onClear={this.onExitTranslate}
                                defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                                onSelectDefault={language => this.onChange('languageCode', language.code)}
                                onRemove={this.onRemoveTranslate} />
                        }
                    />
                    <FormActionComponent
                        onSubmit={this.onSubmit}
                        isSubmit={isSubmit}
                        action={action}
                        isGetItem={isGetItem}
                        onClickBack={this.onClickBack}
                        backButtonText={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.cancel`) : t(`action.back`)}
                        titleButtonSubmit={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.save`) : undefined}
                        onChangeActive={e => this.onChangeDetail(e.name, e.value)}
                        submitButtonRight={true}
                        statusActiveName={`isActive`}
                    >
                        <Wrapper className='col-md-12 basic-section'>
                            <FormWrapperItem>
                                <Wrapper className="col-md-2" />
                                <Wrapper className="col-md-8">
                                    <FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={page.title}
                                        validation={validation.title}
                                        labelTitle={t(`item.page.title`)}
                                    >
                                        <Input placeholder="" type={`text`}
                                            className={`form-control`}
                                            name={`title`} onChange={(e) => this.onChange('title', e.target.value)}
                                            value={checkUndefine(page.title)} />
                                    </FormWrapperInputComponent>
                                    {action === 'UPDATE' &&
                                        <FormWrapperInputComponent
                                            labelTitle={t(`item.page.urlSlug`)}
                                        >
                                            <Input placeholder="" type={`text`}
                                                readOnly
                                                className={`form-control`}
                                                name={`urlSlug`} onChange={(e) => this.onChange('urlSlug', e.target.value)}
                                                value={checkUndefine(page.urlSlug)} />
                                        </FormWrapperInputComponent>
                                    }
                                    <FormWrapperInputComponent
                                        labelTitle={t(`item.page.description`)}
                                    >
                                        <RichTextEditor
                                            editor={ClassicEditor}
                                            config={{ uploadDirectory: UPLOAD_DIRECTORY.PAGE }}
                                            data={checkUndefine(page.description)}
                                            onChange={(event, editor) => {
                                                const data = editor.getData();
                                                return this.onChange("description", data)
                                            }}
                                        />
                                    </FormWrapperInputComponent>
                                    <FormWrapperInputComponent
                                        labelTitle={t(`item.page.content`)}
                                    >
                                        <RichTextEditor
                                            editor={ClassicEditor}
                                            config={{ uploadDirectory: UPLOAD_DIRECTORY.PAGE }}
                                            data={checkUndefine(page.content)}
                                            onChange={(event, editor) => {
                                                const data = editor.getData();
                                                return this.onChange("content", data)
                                            }}
                                        />
                                    </FormWrapperInputComponent>
                                </Wrapper>
                                <Wrapper className="col-md-2" />
                            </FormWrapperItem>
                        </Wrapper>
                    </FormActionComponent>
                </PageListComponent>
            </LoadingComponent>
        );
    }

    onChange = (fieldName, value) => {
        const page = this.state.page;
        page[fieldName] = value.trimLeft();
        if (fieldName === 'title') {
            page.urlSlug = Func.stringToUrlSlug(value);
        }
        this.setState({ page });
    };

    onClickBack = () => {
        if(this.state.action === DETAIL_ACTIONS.TRANSLATE){
            this.onExitTranslate();
        } else {
            this.props.history.push(PATHS.PAGE.LIST.path);
        }
    }

    onShowTranslate = (language) => {
        const { page } = this.state;
        page.setTranslate(language.code);
        page.setData();
        this.setState({ page, action: DETAIL_ACTIONS.TRANSLATE });
    }

    onExitTranslate = () => {
        const page = cloneDeep(this.state.page);
        const action = DETAIL_ACTIONS[page.id ? 'UPDATE' : 'CREATE'];
        page.setTranslate(undefined, true);
        page.setData();
        this.setState({ page, action });
    }

    onSaveTranslate = () => {
        const { page } = this.state;
        const translateFunction = page.translate.id ? this.props.updatePageTranslate : this.props.createPageTranslate;
        translateFunction(page, page.languageCode);
        this.onExitTranslate();
    }

    onRemoveTranslate = (language) => {
        const { page } = this.state;
        page.setTranslate(language.code);
        this.props.deletePageTranslate(page, { id: page.id });
    }

    onSubmit = (e) => {
        e.preventDefault();
        const { page, action } = this.state;
        if (this.validate()) {
            if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
                this.onSaveTranslate()
            } else if (action === DETAIL_ACTIONS.CREATE) {
                this.props.createPageDetail(page)
            } else {
                this.props.updatePageDetail({ page, props: this.props })
            }
        }
    };

    validate() {
        const { t } = this.props;
        let validate = {
            required: {
                title: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.page.title`)),
            }
        };
        if (this.state.action === DETAIL_ACTIONS.CREATE) {
            validate.required.languageCode = Func.formatValidation(t('validation.statusCode.code.1'), t(`translate.defaultLanguage`));
        }
        let valueValidate = {

        };
        const result = Func.multipleValidate(this.state.page, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }
}
